import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

interface DialogBoxProps {
  openDraftDialog: boolean;
  setOpenDraftDialog: (open: boolean) => void;
  saveAsDraft: (type: string) => Promise<void>;
  dialogAction: "draft" | "review" | "signoff" | "savecomments" | null;
}

const ConfirmationModalPopUp: React.FC<DialogBoxProps> = ({
  openDraftDialog,
  setOpenDraftDialog,
  saveAsDraft,
  dialogAction,
}) => {
  const handleConfirm = async () => {
    if (dialogAction === "draft") {
      await saveAsDraft("SAVE_AS_DRAFT");
    } else if (dialogAction === "review") {
      await saveAsDraft("SUBMIT_FOR_REVIEW");
    } else if (dialogAction === "signoff") {
      await saveAsDraft("SIGN_OFF");
    } else if (dialogAction === "savecomments") {
      await saveAsDraft("SAVE_COMMENTS");
    }
    setOpenDraftDialog(false);
  };

  const getDialogText = (dialogAction: string | null) => {
    switch (dialogAction) {
      case "draft":
        return {
          heading: " Save as Draft",
          description: " Save the Comments?",
        };
      case "review":
        return {
          heading: " Submit for Review",
          description: " Submit for Review?",
        };
      case "signoff":
        return {
          heading: " Sign Off",
          description: " Sign Off the Comments?",
        };
      case "savecomments":
        return {
          heading: " Save Comments",
          description: " Save the Comments?",
        };
      default:
        return {
          heading: "",
          description: "",
        };
    }
  };

  const { heading, description } = getDialogText(dialogAction);
  return (
    <>
      <Dialog open={openDraftDialog} onClose={() => setOpenDraftDialog(false)}>
        <DialogTitle>
          Confirm
          {heading}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {description}
            {dialogAction === "draft" && (
              <Typography variant="h6">
                (Note: By saving your comments will only save temporarily, will
                not submit until you click on 'Submit for Review')
              </Typography>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="btn-optional"
            onClick={() => setOpenDraftDialog(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className="btn-mandatory"
            onClick={handleConfirm}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationModalPopUp;